import { useCrmEnrichmentJobCache } from "app/pages/sales-intelligence/modules/crm-enrichment/hooks/useCrmEnrichmentJobCache";

import { hubspotEnrichmentQueryKeys } from "../queries/queryKeyFactory";

export const useHsEnrichmentJobCache = () => useCrmEnrichmentJobCache(hubspotEnrichmentQueryKeys);
